import _styled, { default as _styled2, default as _styled3 } from "styled-components";
import { getThemeStyle, type Mode, type Theme } from "~/features/ui/get-theme-style";
export type SpecsRowSpecViewProps = {
  mode: Mode;
  name?: string | null;
  theme: Theme;
  value?: string | null;
};
export function SpecsRowSpecView({
  mode,
  name,
  theme,
  value
}: SpecsRowSpecViewProps) {
  const themeStyle = getThemeStyle({
    mode,
    theme
  });
  return <_StyledDiv $_css={[{
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "columnGap": "4rem",
    "padding": "1.6rem",
    "textAlign": "center",
    "@media (min-width: 1024px)": {
      "padding": "2rem"
    }
  }]}>
      <_StyledP $_css2={[{
      "fontSize": "1.6rem",
      "lineHeight": "1.5",
      "fontWeight": "500",
      "@media (min-width: 1024px)": {
        "fontSize": "1.8rem",
        "lineHeight": "1.5",
        "letterSpacing": "0.018rem",
        "fontWeight": "500"
      }
    }, themeStyle.text]}>{name}</_StyledP>
      <_StyledP2 $_css3={[{
      "fontFamily": "Aeonik, ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif",
      "fontSize": "1.4rem",
      "lineHeight": "1.1",
      "letterSpacing": "0.028000000000000004rem",
      "fontWeight": "400",
      "@media (min-width: 1024px)": {
        "fontSize": "1.6rem",
        "lineHeight": "1.1",
        "letterSpacing": "0.032rem",
        "fontWeight": "400"
      }
    }, themeStyle.label]}>
        {value}
      </_StyledP2>
    </_StyledDiv>;
}
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  componentId: "sc-sf-10delzo-0"
})`${p => p.$_css}`;
var _StyledP = _styled2("p").withConfig({
  componentId: "sc-sf-10delzo-1"
})`${p => p.$_css2}`;
var _StyledP2 = /*#__PURE__*/_styled3("p").withConfig({
  displayName: "specs-row-spec___StyledP2",
  componentId: "sc-uv1f17-0"
})(["", ""], p => p.$_css3);